import { type LiftedLinks, prependPathWithParams } from '@dhl/utils'
import { addressLinks, type AddressLinks } from './addresses/links.js'
import { deleteAccountLinks, type DeleteAccountLinks } from './deleteAccount/links.js'
import { emailAddressLinks, type EmailAddressLinks } from './emailAdresses/links.js'
import { mobileNumberLinks, type MobileNumberLinks } from './mobileNumber/links.js'

export const paths = {
  NAME: 'name',
  DELETE_ACCOUNT_CONFIRMATION: 'confirmation',
  DELETE_ACCOUNT_PASSWORD: 'password',
  DELETE_ACCOUNT: 'delete-account',
  ADDRESSES: 'addresses',
  EMAIL_ADDRESSES: 'email-addresses',
  MOBILE_NUMBER: 'mobile-number',
  CHANGE_PASSWORD: 'change-password',
}

export const settingsLinks: SettingsLinks = {
  ...prependPathWithParams(() => paths.ADDRESSES, addressLinks),
  ...prependPathWithParams(() => paths.EMAIL_ADDRESSES, emailAddressLinks),
  ...prependPathWithParams(() => paths.MOBILE_NUMBER, mobileNumberLinks),
  ...prependPathWithParams(() => paths.DELETE_ACCOUNT, deleteAccountLinks),
  nameSettingLink: () => `/${paths.NAME}`,
  addressesLink: () => `/${paths.ADDRESSES}`,
  emailAddressesLink: () => `/${paths.EMAIL_ADDRESSES}`,
  mobileNumberLink: () => `/${paths.MOBILE_NUMBER}`,
  deleteAccountLink: () => `/${paths.DELETE_ACCOUNT}`,
  changePasswordLink: () => `/${paths.CHANGE_PASSWORD}`,
}

export type SettingsLinks = LiftedLinks<AddressLinks, unknown, false> &
  LiftedLinks<EmailAddressLinks, unknown, false> &
  LiftedLinks<MobileNumberLinks, unknown, false> &
  LiftedLinks<DeleteAccountLinks, unknown, false> & {
    nameSettingLink: () => string
    addressesLink: () => string
    emailAddressesLink: () => string
    mobileNumberLink: () => string
    deleteAccountLink: () => string
    changePasswordLink: () => string
  }
